// @flow
import RxVideoStreamer from '../components/player/VideoStreamer/RxVideoStreamer/RxVideoStreamer';
export default RxVideoStreamer;
